<div fxLayout="row" class="container" fxFlex="100" fxLayoutAlign="space-between" [formGroup]="formGroup">
  <!-- First column -->
  <div class="column" fxLayout="column" fxFlex="32">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'FirstName' | translate }}</mat-label>
      <input matInput type="text" formControlName="firstName" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'LastName' | translate }}</mat-label>
      <input matInput type="text" formControlName="lastName" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'Status' | translate }}</mat-label>
      <mat-select formControlName="statusId" multiple>
        @for (absenceStatus of absenceStatuses$ | async; track absenceStatus) {
          <mat-option [value]="absenceStatus.Id">
            {{ absenceStatus.Name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Second column -->
  <div class="column" fxLayout="column" fxFlex="32">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Company' | translate }}</mat-label>
      <input
        matInput
        formControlName="company"
        placeholder="{{ 'Company' | translate }}"
        [matAutocomplete]="autocompleteEmployerObject"
        [errorStateMatcher]="matcher"
        />
        <mat-autocomplete #autocompleteEmployerObject="matAutocomplete" [displayWith]="displayValue">
          @for (company of companies$ | async; track company) {
            <mat-option [value]="company">
              {{ company.Name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <div class="control">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EAbsenceConclusionsListFilters.StartDateFrom' | translate }}</mat-label>
          <input matInput [matDatepicker]="startDateFromPicker" formControlName="startDateFrom" autocomplete="date" />
          <mat-datepicker-toggle [for]="startDateFromPicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #startDateFromPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="control">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EAbsenceConclusionsListFilters.EndDateFrom' | translate }}</mat-label>
          <input matInput [matDatepicker]="endDateFromPicker" formControlName="endDateFrom" autocomplete="date" />
          <mat-datepicker-toggle [for]="endDateFromPicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #endDateFromPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <!-- Third column -->
    <div class="column" fxLayout="column" fxFlex="32">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'AbsenceType' | translate }}</mat-label>
        <mat-select formControlName="absenceTypeId" multiple>
          @for (absenceType of absenceTypes$ | async; track absenceType) {
            <mat-option [value]="absenceType.Id">
              {{ absenceType.Name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="control">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EAbsenceConclusionsListFilters.StartDateTo' | translate }}</mat-label>
          <input matInput [matDatepicker]="startDateToPicker" formControlName="startDateTo" autocomplete="date" />
          <mat-datepicker-toggle [for]="startDateToPicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #startDateToPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="control">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EAbsenceConclusionsListFilters.EndDateTo' | translate }}</mat-label>
          <input matInput [matDatepicker]="endDateToPicker" formControlName="endDateTo" autocomplete="date" />
          <mat-datepicker-toggle [for]="endDateToPicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #endDateToPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
